import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Shield,
  AlertCircle,
  FileText,
  Receipt,
  BarChart3,
  FolderOpen,
  Settings,
  ChevronLeft,
  ChevronRight,
  Bell
} from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const Sidebar = ({ collapsed, onToggle }) => {
  const { user } = useAuth();

  const menuItems = [
    { path: '/dashboard', icon: LayoutDashboard, label: 'Dashboard', roles: ['admin', 'agente', 'vendedor', 'tecnico', 'cliente'] },
    { path: '/garantias', icon: Shield, label: 'Garantías', roles: ['admin', 'agente', 'vendedor', 'tecnico'] },
    { path: '/cliente/garantia', icon: Shield, label: 'Mi Garantía', roles: ['cliente'] },
    { path: '/averias', icon: AlertCircle, label: 'Averías', roles: ['admin', 'agente', 'vendedor', 'tecnico'] },
    { path: '/cliente/averias', icon: AlertCircle, label: 'Mis Averías', roles: ['cliente'] },
    { path: '/contratos', icon: FileText, label: 'Contratos', roles: ['admin', 'agente'] },
    { path: '/facturacion', icon: Receipt, label: 'Facturación', roles: ['admin', 'agente'] },
    { path: '/estadisticas', icon: BarChart3, label: 'Estadísticas', roles: ['admin', 'agente', 'vendedor'] },
    { path: '/documentos', icon: FolderOpen, label: 'Documentos', roles: ['admin', 'agente', 'vendedor', 'tecnico'] },
    { path: '/cliente/documentos', icon: FolderOpen, label: 'Mis Documentos', roles: ['cliente'] },
    { path: '/cliente/notificaciones', icon: Bell, label: 'Notificaciones', roles: ['cliente'] },
    { path: '/admin', icon: Settings, label: 'Administración', roles: ['admin'] },
    { path: '/cliente/configuracion', icon: Settings, label: 'Configuración', roles: ['cliente'] },
  ];

  const visibleItems = menuItems.filter(item => item.roles.includes(user?.role));

  return (
    <aside className={`bg-white border-r border-gray-200 transition-all duration-200 ${collapsed ? 'w-16' : 'w-60'} flex flex-col`}>
      {!collapsed && (
        <div className="px-5 py-4 border-b border-gray-100">
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 bg-primary-700 rounded-lg flex items-center justify-center">
              <Shield className="w-5 h-5 text-white" />
            </div>
            <div>
              <h1 className="text-base font-bold text-gray-900">RD Garantía</h1>
              <p className="text-xs text-gray-500">Gestión de Garantías</p>
            </div>
          </div>
        </div>
      )}

      <nav className="flex-1 px-2 py-3 space-y-0.5 overflow-y-auto">
        {visibleItems.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `flex items-center px-3 py-2 rounded-lg transition-colors duration-150 text-sm ${
                  isActive
                    ? 'bg-primary-50 text-primary-800 font-medium'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                }`
              }
            >
              <Icon className="w-5 h-5 flex-shrink-0" />
              {!collapsed && (
                <span className="ml-3">{item.label}</span>
              )}
            </NavLink>
          );
        })}
      </nav>

      <div className="p-2 border-t border-gray-100">
        <button
          onClick={onToggle}
          className="w-full flex items-center justify-center px-3 py-2 text-gray-500 hover:bg-gray-50 hover:text-gray-700 rounded-lg transition-colors text-sm"
        >
          {collapsed ? (
            <ChevronRight className="w-4 h-4" />
          ) : (
            <>
              <ChevronLeft className="w-4 h-4" />
              <span className="ml-2">Contraer</span>
            </>
          )}
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
